import { BackButton } from '../../components/BackButton';
import { StepProgress } from '../../components/StepProgress';
import { CalendarIcon } from '../../icons/CalendarIcon';
import { Bar, ItineraryButton, ItineraryLabel, TrailingAction } from './ActionBar.styles';
import type { ActionBarProps } from './ActionBar.types';

export function ActionBar({
  onBack,
  backAriaLabel = 'Go back',
  currentStep = 1,
  totalSteps,
  progressLabel,
  progressValueText,
  onItineraryClick,
  itineraryLabel = 'Itinerary',
}: ActionBarProps) {
  const showProgress = totalSteps != null && totalSteps > 0;

  if (!onBack && !showProgress && !onItineraryClick) {
    return null;
  }

  return (
    <Bar>
      {onBack && <BackButton variant="contained" onClick={onBack} ariaLabel={backAriaLabel} />}
      {showProgress && (
        <StepProgress
          currentStep={currentStep}
          totalSteps={totalSteps}
          label={progressLabel}
          valueText={progressValueText}
        />
      )}
      {onItineraryClick && (
        <TrailingAction>
          <ItineraryButton type="button" onClick={onItineraryClick} aria-haspopup="dialog">
            <CalendarIcon size={24} />
            <ItineraryLabel>{itineraryLabel}</ItineraryLabel>
          </ItineraryButton>
        </TrailingAction>
      )}
    </Bar>
  );
}
